/** @jsx dom */
import {render, renderString, tree} from '@viskan/deku';
import {storePlugin} from '@viskan/deku-redux';
import dom from 'magic-virtual-element';
import store from 'store2';
import actions from './actions';
import analytics, {setOrigin} from './analytics';
import App from './app';
import {catchClientErrors, handleDekuError} from './error';
import customer from './sources/customer';
import * as redux from './redux';
import router from './router';
import sessionCheck from './session-check';
import shopcart from './sources/shopcart';
import sources from './sources';

setOrigin();
sessionCheck();

const options = store('vs-debug') || {};

if (!options.crashOnError) {
	catchClientErrors();
}

const app = tree(<App/>)
	.use(storePlugin(redux.store))
	.use(actions)
	.use(customer)
	.use(sources)
	.use(shopcart)
	.use(analytics)
	.use(router);

const instance = render(app, document.querySelector('#Streamline'), {
	errorHandler: options.crashOnError ? undefined : handleDekuError
});

window._debug = options => store('vs-debug', options);
window._injectReducer = redux.injectReducer;
window._reduxStore = redux.store;
window._renderHtmlString = () => renderString(instance);
